import * as DomBuilder from "./dom-builder.js";

/**
 *
 * @version 2026-09-01
 * @author Patrik Harag
 */
export default class ComponentOptionsCategories {

    /** @type {function(boolean)} */
    #refreshFunction;
    /** @type {boolean} */
    #checked;
    /** @type {HTMLElement} */
    #node;

    /**
     *
     * @param enableCategories {boolean}
     * @param refreshFunction {function(boolean)}
     */
    constructor(enableCategories, refreshFunction) {
        this.#checked = enableCategories;
        this.#refreshFunction = refreshFunction;
    }

    createNode() {
        let labelContent = DomBuilder.element('i', { class: 'fa fa-th' });
        let toggleButton = DomBuilder.bootstrapToggleButton(labelContent, 'btn-secondary', this.#checked, b => {
            this.#checked = b;
            this.#refreshFunction(b);
        });

        this.#node = DomBuilder.div({ class: 'categories-component' }, toggleButton);
        return this.#node;
    }

    setDisabled(disabled) {
        if (disabled) {
            this.#node.style.display = 'none';
        } else {
            this.#node.style.display = '';
        }
    }

    isSelected() {
        return this.#checked;
    }
}
